import { Outlet } from "react-router-dom";
import { useState } from "react";

import Navbar from "../components/Navbar/Navbar";
import Sidebar from "../components/Sidebar/Sidebar";

import styles from "./AppLayout.module.css"
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import usePageTitle from "../hooks/usePageTitle";

function AppLayout() {

    const { ready } = useContext(AuthContext);
    const [isCollapsed, setIsCollapsed] = useState(true);
    
    // Update page title based on current route
    usePageTitle();

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    if (ready === false) {
        return <div className={styles.layoutLoading}>Loading…</div>
    }

    return (
        <div className={styles["layout-container"]}>
            <Navbar onToggleSidebar={toggleSidebar} />
            <div className={styles["layout-body"]}>
                <Sidebar isCollapsed={isCollapsed} />
                <div className={styles["layout-content"]}>
                    <div className={styles["layout-main"]}>
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AppLayout;
